import { LegalLayout } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Termos de Uso" lastUpdated="31 de maio de 2026">
      <p>
        Estes Termos de Uso (&quot;Termos&quot;) regulam o acesso e uso da plataforma
        Naturexpress, disponível em{" "}
        <a href="https://naturexpress.com.br">naturexpress.com.br</a> (&quot;Plataforma&quot;),
        operada por <strong>Naturexpress Produtos Alimentícios LTDA</strong>, inscrita no
        CNPJ sob o nº 61.441.516/0001-66 (&quot;Naturexpress&quot;, &quot;nós&quot;). Ao criar uma conta ou
        utilizar a Plataforma, você (&quot;Cliente&quot;, &quot;você&quot;) declara concordar
        integralmente com estes Termos.
      </p>

      <h2>1. Sobre a Plataforma</h2>
      <p>
        A Naturexpress oferece uma plataforma B2B para que pessoas jurídicas — como
        restaurantes, supermercados e cozinhas industriais — realizem pedidos recorrentes
        de hortifrúti e produtos alimentícios diretamente com a Naturexpress.
      </p>

      <h2>2. Cadastro e elegibilidade</h2>
      <ul>
        <li>O uso da Plataforma é restrito a pessoas jurídicas com CNPJ ativo no Brasil.</li>
        <li>Você deve fornecer informações verdadeiras, completas e atualizadas no cadastro.</li>
        <li>
          Você é responsável pela confidencialidade das credenciais de acesso (incluindo a
          conta Google associada, quando o login federado for utilizado) e por toda
          atividade realizada em sua conta.
        </li>
        <li>
          A Naturexpress reserva-se o direito de validar os dados cadastrais e recusar ou
          suspender contas com informações inconsistentes ou suspeitas de fraude.
        </li>
      </ul>

      <h2>3. Pedidos, preços e pagamentos</h2>
      <ul>
        <li>
          Os preços exibidos são específicos para cada cliente, podendo variar conforme
          tabela comercial vinculada à sua conta.
        </li>
        <li>
          A confirmação do pedido depende de validação interna, disponibilidade de estoque
          e cumprimento da janela de fechamento informada na Plataforma.
        </li>
        <li>
          Condições de pagamento, prazos e modalidades aceitas são definidas no momento da
          contratação comercial e podem variar por cliente.
        </li>
        <li>
          O Cliente é responsável pela conferência dos produtos, quantidades e preços antes
          da confirmação do pedido.
        </li>
      </ul>

      <h2>4. Entregas</h2>
      <ul>
        <li>
          As janelas de entrega são definidas conforme região, tipo de operação e
          configuração comercial do Cliente.
        </li>
        <li>
          O Cliente deve garantir local adequado para recebimento e pessoa autorizada para
          conferência e assinatura no momento da entrega.
        </li>
        <li>
          Eventuais divergências (produto faltante, qualidade ou quantidade) devem ser
          registradas no ato do recebimento para análise.
        </li>
      </ul>

      <h2>5. Cancelamentos e devoluções</h2>
      <p>
        Pedidos confirmados podem ser cancelados apenas dentro da janela de fechamento.
        Após esse prazo, alterações dependem de avaliação da equipe comercial.
        Devoluções de produtos perecíveis seguem critérios específicos definidos no momento
        da entrega.
      </p>

      <h2>6. Uso adequado</h2>
      <p>Você concorda em não:</p>
      <ul>
        <li>Utilizar a Plataforma para finalidades ilícitas ou fraudulentas.</li>
        <li>Tentar acessar áreas restritas, sistemas ou dados de terceiros.</li>
        <li>Interferir no funcionamento da Plataforma (ataques, engenharia reversa, scraping não autorizado).</li>
        <li>Compartilhar suas credenciais de acesso com terceiros não autorizados.</li>
      </ul>

      <h2>7. Propriedade intelectual</h2>
      <p>
        Todo o conteúdo da Plataforma — incluindo marca, logotipos, layout, código,
        catálogo e textos — é de propriedade da Naturexpress ou de seus licenciantes,
        protegido pelas leis de propriedade intelectual. É vedada a reprodução total ou
        parcial sem autorização prévia e por escrito.
      </p>

      <h2>8. Privacidade e proteção de dados</h2>
      <p>
        O tratamento de dados pessoais é regido pela nossa{" "}
        <a href="/privacy">Política de Privacidade</a>, parte integrante destes Termos.
      </p>

      <h2>9. Suspensão e encerramento</h2>
      <p>
        A Naturexpress pode suspender ou encerrar o acesso de Clientes que violem estes
        Termos, com ou sem aviso prévio, conforme a gravidade da conduta. O encerramento
        não exime as partes do cumprimento de obrigações pendentes.
      </p>

      <h2>10. Limitação de responsabilidade</h2>
      <p>
        A Plataforma é fornecida &quot;no estado em que se encontra&quot;. A Naturexpress envida seus
        melhores esforços para manter disponibilidade e correção das informações, mas não
        garante operação ininterrupta ou isenta de erros. Na máxima extensão permitida por
        lei, a responsabilidade da Naturexpress limita-se aos danos diretos e
        comprovadamente causados por nossa atuação.
      </p>

      <h2>11. Alterações nestes Termos</h2>
      <p>
        Podemos atualizar estes Termos a qualquer momento. Alterações relevantes serão
        comunicadas por e-mail ou aviso na Plataforma com antecedência razoável. O uso
        continuado após a entrada em vigor das alterações constitui aceitação.
      </p>

      <h2>12. Lei aplicável e foro</h2>
      <p>
        Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o
        foro da comarca da sede da Naturexpress para dirimir quaisquer controvérsias,
        renunciando-se a qualquer outro, por mais privilegiado que seja.
      </p>

      <h2>13. Contato</h2>
      <p>
        <strong>Naturexpress Produtos Alimentícios LTDA</strong>
        <br />
        CNPJ: 61.441.516/0001-66
        <br />
        Rua das Acácias, 134, Galpão Box 1
        <br />
        Vila Independência — Cariacica/ES
        <br />
        CEP 29148-650
        <br />
        E-mail:{" "}
        <a href="mailto:contato@naturexpress.com.br">contato@naturexpress.com.br</a>
      </p>
    </LegalLayout>
  );
}
